module.exports = __webpack_public_path__ + "37f8b76a934293a57b9103bf404e0d03.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-11.png
// module id = 1625
// module chunks = 0